import AdapterLuxon from '@mui/lab/AdapterLuxon';
import { DateTime, Info } from 'luxon';

export function AdapterDateLuxon(weekStartsOn: number) {
  class Adapter extends AdapterLuxon {
    private weekStartsOn = weekStartsOn;

    /** Controls the header of the calendar month view. */
    public getWeekdays = () => {
      const weekdays = Info.weekdaysFormat('narrow', { locale: this.locale });
      const start = weekdays.slice(0, this.weekStartsOn - 1);
      const end = weekdays.slice(this.weekStartsOn - 1);
      return [...end, ...start];
    };

    /** Controls the day buttons of the calendar month view. */
    getWeekArray = (date: DateTime) => {
      const startOfMonth = date.startOf('month');
      const endOfMonth = date.endOf('month');
      const firstDayOfMonth = startOfMonth.weekday;

      const startOfWeek = startOfMonth.minus({
        days: (firstDayOfMonth - this.weekStartsOn + 7) % 7,
      });

      const endOfWeek = endOfMonth.plus({ days: 6 - endOfMonth.weekday + this.weekStartsOn }).endOf('day');

      const { days } = endOfWeek.diff(startOfWeek, 'days').toObject();

      const weeks: DateTime[][] = [];
      new Array<number>(Math.round(days ?? 0))
        .fill(0)
        .map((_, i) => i)
        .map((day) => startOfWeek.plus({ days: day }))
        .forEach((v, i) => {
          if (i === 0 || (i % 7 === 0 && i > 6)) {
            weeks.push([v]);
            return;
          }
          weeks[weeks.length - 1].push(v);
        });
      return weeks;
    };
  }
  return Adapter;
}
